import { EventEmitter, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '@services';
import UiValidators, { UI_COMMENT_MAX_LENGTH } from '@validators';
var UiCommentComponent = /** @class */ (function () {
    function UiCommentComponent(fb, _modalService, _translateService) {
        this._modalService = _modalService;
        this._translateService = _translateService;
        this.edited = new EventEmitter();
        this.updated = new EventEmitter();
        this.deleted = new EventEmitter();
        this.editing = false;
        this.saving = false;
        this.current = {};
        this.form = fb.group({
            'text': [this.original && this.original.text, Validators.compose([
                    UiValidators.required(),
                    Validators.maxLength(UI_COMMENT_MAX_LENGTH)
                ])],
        });
    }
    Object.defineProperty(UiCommentComponent.prototype, "model", {
        set: function (value) {
            this.original = value;
            this.current = Object.assign(this.current, this.original);
            this.form.get('text').setValue(this.current.text);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCommentComponent.prototype, "dirty", {
        get: function () {
            return this.form.get('text').value !== this.original.text;
        },
        enumerable: true,
        configurable: true
    });
    UiCommentComponent.prototype.edit = function () {
        var _this = this;
        this.edited.emit({
            comment: this.original,
            continue: function () {
                _this.current = Object.assign(_this.current, _this.original);
                _this.form.get('text').setValue(_this.current.text);
                _this.editing = true;
            },
        });
    };
    UiCommentComponent.prototype.delete = function () {
        var _this = this;
        this._modalService.onConfirm(null, function () { return _this.deleted.emit({
            comment: _this.original,
            success: function () { },
            error: function () { },
        }); }, function () { }, this._translateService.instant('comments_delete_comment_warning'));
    };
    UiCommentComponent.prototype.save = function () {
        var _this = this;
        if (!this.form.valid) {
            return;
        }
        this.current.text = this.form.get('text').value;
        this.saving = true;
        this.updated.emit({
            comment: this.current,
            success: function () {
                _this.original = Object.assign(_this.original, _this.current);
                _this.saving = false;
                _this.editing = false;
                _this.form.reset(_this.form.value);
            },
            error: function () { return _this.saving = false; },
        });
    };
    UiCommentComponent.prototype.cancel = function () {
        this.current = Object.assign(this.current, this.original);
        this.form.get('text').setValue(this.current.text);
        this.editing = false;
    };
    return UiCommentComponent;
}());
export { UiCommentComponent };
